import React, { FC } from "react"

interface ActionButtonsProps {
  status: string
  onStatusChange?: (newStatus: string) => void
  onEdit?: () => void
  onCancel?: () => void
}

const ActionButtons: FC<ActionButtonsProps> = ({
  status,
  onStatusChange,
  onEdit,
  onCancel
}) => {
  const handleStatusChange = (newStatus: string) => {
    onStatusChange?.(newStatus)
  }

  const handleCancel = () => {
    onCancel?.()
  }

  return (
    <div className="flex gap-4 justify-end pt-6 border-t border-gray-200">
      {/* 未承認の場合：架電予定に変更ボタン */}
      {status === 'unapproved' && (
        <button
          onClick={() => handleStatusChange('callout')}
          className="inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-blue-500 text-white rounded-lg text-sm font-medium transition-all hover:bg-blue-600 hover:-translate-y-0.5 hover:shadow-md focus:outline-none focus:ring-3 focus:ring-blue-500/10 min-h-[2.5rem]"
        >
          架電予定に変更
        </button>
      )}
      
      {/* 編集ボタン：承認済みと架電予定の場合のみ表示 */}
      {(status === 'approved' || status === 'callout') && (
        <button
          onClick={onEdit}
          className="inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-gray-100 text-gray-900 border border-gray-200 rounded-lg text-sm font-medium transition-all hover:bg-gray-200 hover:-translate-y-0.5 focus:outline-none focus:ring-3 focus:ring-gray-500/10 min-h-[2.5rem]"
        >
          編集
        </button>
      )}
      
      {/* 予約のキャンセルボタン：未承認、承認済み、架電予定の場合に表示 */}
      {(status === 'unapproved' || status === 'approved' || status === 'callout') && (
        <button
          onClick={handleCancel}
          className="inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-red-500 text-white rounded-lg text-sm font-medium transition-all hover:bg-red-600 hover:-translate-y-0.5 hover:shadow-md focus:outline-none focus:ring-3 focus:ring-red-500/10 min-h-[2.5rem]"
        >
          予約のキャンセル
        </button>
      )}
    </div>
  )
}

export default ActionButtons

